<template>
  <div class="header d-flex flex-wrap" v-if="isMode !== 'map'">
    <div class="title-mobile">
      <!-- v-bind:style="{ backgroundImage: 'url(./map_BG-mobile.png)' }" -->
      <div style="margin: 0px 14px">
        <a
          target="_blank"
          href="https://covid19.longdo.com"
          style="
            color: #fff;
            text-decoration: none;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          "
        >
          <div style="display: flex; flex-direction: row">
            <div style="font-size: 22px">สถานการณ์ผู้ติดเชื้อ</div>
            <div class="covid19-text">
              <span style="color: #fecb01; font-size: 22px; margin-left: 3px"
                >ไวรัส</span
              >
              COVID-19
            </div>
          </div>
          <!-- <div>ในประเทศไทย</div> -->
          <div class="date-mobile">{{ status.UpdateDate }}</div>
        </a>
      </div>
    </div>
    <v-col class="column-container title-web" cols="12">
      <div class="title-area-text" style="width: 100%; height: 100%">
        <div class="title-area-container">
          <a
            target="_blank"
            href="https://covid19.longdo.com"
            style="
              color: #fff;
              text-decoration: none;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <div style="display: flex; flex-direction: row">
              <div style="font-size: 1.9em">สถานการณ์ผู้ติดเชื้อ</div>
              <div
                style="
                  font-size: 1.9em;
                  color: #ef0400;
                  font-weight: bold;
                  margin-left: 3px;
                "
              >
                <span class="yellow-font">ไวรัส</span> COVID-19
              </div>
            </div>
            <!-- <br /> -->
            <span style="font-size: 0.9em; color: rgb(191, 191, 191)">{{
              status.UpdateDate
            }}</span>
          </a>
        </div>
      </div>
    </v-col>
    <v-col class="column-container pa-1 align-self-center" cols="12">
      <div class="d-flex flex-column">
        <div class="d-flex">
          <v-card
            v-show="!isDesktop"
            class="ma-1 report-header confirmedCard"
            color=""
            style="width: 100%"
          >
            <div class="report-title">ผู้ติดเชื้อสะสม</div>
            <div class="report-number">{{ status.Confirmed }}</div>
            <div class="added-number-report">
              <div style="background-color: #df5a05">
                {{ status.NewConfirmed }}
              </div>
            </div>
          </v-card>
        </div>
        <div class="d-flex">
          <v-card
            v-show="isDesktop"
            class="ma-1 report-header confirmedCard flex-2"
            color=""
            style="width: 100%"
          >
            <div class="report-title">ผู้ติดเชื้อสะสม</div>
            <div class="report-number-sub">{{ status.Confirmed }}</div>
            <div class="added-number-report">
              <div style="background-color: #df5a05">
                {{ status.NewConfirmed }}
              </div>
            </div>
          </v-card>
          <!-- <v-card
            class="ma-1 report-header hospitalizedCard flex-1"
            color="#"
            style="width: 100%"
          >
            <div class="report-title">กำลังรักษา</div>
            <div class="report-number-sub">{{ status.Hospitalized }}</div>
            <div class="added-number-report">
              <div style="background-color: #068382">
                {{ status.NewHospitalized }}
              </div>
            </div>
          </v-card> -->
          <v-card
            class="ma-1 report-header recoveredCard flex-1"
            color="#"
            style="width: 100%"
          >
            <div class="report-title">หายแล้ว</div>
            <div class="report-number-sub">{{ status.Recovered }}</div>
            <div class="added-number-report">
              <div style="background-color: #0a7519">
                {{ status.NewRecovered }}
              </div>
            </div>
          </v-card>
          <v-card
            class="ma-1 report-header deathsCard flex-1"
            color="#"
            style="width: 100%"
          >
            <div class="report-title">เสียชีวิต</div>
            <div class="report-number-sub">{{ status.Deaths }}</div>
            <div class="added-number-report">
              <div style="background-color: #ae040c">
                {{ status.NewDeaths }}
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import moment from "moment";
require("moment/locale/th");
// import status from "@/assets/status.json";

Vue.use(require("vue-moment"), {
  moment,
});
Vue.use(VueAxios, axios);
export default {
  name: "Header",
  data() {
    return {
      status: {
        Recovered: "-",
        Deaths: "-",
        Hospitalized: "-",
        Confirmed: "-",
        NewRecovered: "-",
        NewConfirmed: "-",
        NewHospitalized: "-",
        NewDeaths: "-",
        UpdateDate: "-",
      },
      addedPercent: "-",
      isMode: undefined,
      monthNamesTH: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤษจิกายน",
        "ธันวาคม",
      ],
      isDesktop: true,
    };
  },
  mounted() {
    let self = this;
    if ("mode" in self.$route.query) {
      self.isMode = self.$route.query.mode;
    }
    let tempDate = "-";

    if (window.innerWidth > 900) {
      self.isDesktop = true;
    } else {
      self.isDesktop = false;
    }

    // .get("https://covid19.th-stat.com/api/open/today")
    Vue.axios
      .get("https://covid19.ddc.moph.go.th/api/Cases/today-cases-all")
      .then((response) => {
        self.status.Recovered = self.numberWithCommas(response.data[0].total_recovered);
        self.status.Deaths = self.numberWithCommas(response.data[0].total_death);
        self.status.Confirmed = self.numberWithCommas(response.data[0].total_case);
        // self.status.Hospitalized = self.numberWithCommas(
        //   response.data[0].Hospitalized
        // );

        self.status.NewDeaths = self.adjustNewCase(response.data[0].new_death);
        self.status.NewConfirmed = self.adjustNewCase(
          response.data[0].new_case
        );
        self.status.NewRecovered = self.adjustNewCase(
          response.data[0].new_recovered
        );
        // self.status.NewHospitalized = self.adjustNewCase(
        //   response.data.NewHospitalized
        // );
        self.status.UpdateDate = response.data[0].update_date;
        tempDate = moment(self.status.UpdateDate, "YYYY-MM-DD HH:mm:ss");
        self.status.UpdateDate =
          "วัน" +
          tempDate.format("dddd") +
          "ที่ " +
          tempDate.format("Do ") +
          tempDate.format("MMMM ") +
          Number(tempDate.year() + 543) +
          " เวลา " + 
          tempDate.format(" HH:mm");
      });
    self.calculatePercent();
  },
  methods: {
    moment: function () {
      return moment();
    },
    calculatePercent() {},
    adjustNewCase(value) {
      const self = this;
      if (value > 0) {
        return "เพิ่ม " + self.numberWithCommas(value) + " ราย";
      } else if (value < 0) {
        return "ลดลง " + self.numberWithCommas(Math.abs(value)) + " ราย";
      } else {
        return "เพิ่ม - ราย";
      }
    },
    numberWithCommas(x) {
      // console.log(x)
      // return x;
      return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>

<style scoped>
.content-container {
  height: 100%;
}
.column-container {
  min-width: 240px;
}
.report-header {
  color: #fff !important;
}
.report-number {
  font-size: 50px;
  display: block;
}
.report-number-sub {
  font-size: 36px;
  font-weight: bold;
}
.report-title {
  padding: 10px;
}
.title-mobile {
  display: none;
}
.confirmedCard {
  background: linear-gradient(71.77deg, #e4620d 0%, #ff8333 100%);
}
.hospitalizedCard {
  background: linear-gradient(50.77deg, #0a807f 0%, #35b8b7 100%);
}
.recoveredCard {
  background: linear-gradient(50.99deg, #177323 0%, #289f38 100%);
}
.deathsCard {
  background: linear-gradient(50.77deg, #b4121a 0%, #e93f47 100%);
}
.title-web {
  padding: 8px 4px;
}
.title-area-text {
  /* color: #ffffff !important; */
  background-color: unset !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 500px 280px;
}
.title-area-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 34px;
  margin-right: auto;
}
.yellow-font {
  color: #fecb02;
}
.covid19-text {
  color: #ef0504;
}
.flex-2 {
  flex: 2;
}
.flex-1 {
  flex: 1;
}
.added-number-report {
  font-size: 21px;
}

.added-number-report > div {
  /* border-radius: 4px; */
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 4px 0px;
}
@media only screen and (max-width: 800px) {
  .report-number {
    font-size: 32px;
    font-weight: 900;
  }
  .report-number-sub {
    font-size: 28px;
  }
  .title-area-text {
    background-size: 0px;
  }
}

@media only screen and (max-width: 600px) {
  body {
  }
  .title-mobile {
    padding: 4px 4px 0px 6px;
    /* box-shadow: 4px 2px 4px 0px grey; */
  }
  .header {
    /* height: unset; */
    /* height: 270px; */
    height: 310px;
  }
  .title-mobile {
    color: #ffffff;
    /* background-color: #09242b !important; */
    /* background-size: 600px; */
    background-size: 390px;
    display: flex;
    font-size: 17;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    height: 100px;
    align-items: flex-start;
  }
  .title-mobile > div {
    margin-left: 132px;
  }
  .title-mobile > .covid19-text {
    color: rgb(239, 4, 0);
    font-weight: bold;
  }
  .date-mobile {
    font-size: 14px;
    color: #dddddd;
  }
  .title-web {
    display: none;
  }
  .column-container {
    min-width: 100%;
  }
  .report-title {
    padding: 6px 6px 0px 6px;
    font-size: 16px;
  }
  .report-number {
    font-size: 28px;
  }
  .report-number-sub {
    font-size: 22px;
  }
  .added-number-report {
    font-size: 16px;
  }
}

@media only screen and (max-width: 350px) {
  .title-mobile {
    font-size: 15px;
  }
  .title-mobile > div {
    margin-left: 100px;
  }
  .date-mobile {
    font-size: 14px;
    /* color: #000000; */
  }
}
</style>
